import { motion } from 'framer-motion';

export const Reveal = ({ children, delay = 0, y = 28, className = '', ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, className = '' }) => (
  <p className={`font-mono text-xs uppercase tracking-[0.3em] text-gold ${className}`}>{children}</p>
);
